import React from "react";
import {AppContext} from "../../app-context";

export const RefreshButton = () => {
  const { setRefreshPending } = React.useContext(AppContext);

  const handleRefresh = async () => {
    await setRefreshPending();
  };

  return (
    <button className="button__login" onClick={handleRefresh}>
      Recharger
    </button>
  );
};
